import { pluralize } from '@zola-helpers/client/dist/es/transformers';

import { ClassNames } from 'react-day-picker';

import { DayPicker } from '~/components/common/zolaUI/renderDatePicker/DayPicker';
import { useSearchResultsPageContext } from '~/pages/couples/explore/components/SearchResults/contexts/SearchResultsPageContext';
import { useVendorSearchNavigation } from '~/pages/couples/explore/components/SearchResults/contexts/VendorSearchNavigationContext';
import { addYears, formatDate, parseDate } from '~/util/dateUtils';

const today = new Date();

const twoYearsOut = addYears(today, 2);

export const AvailabilityFilterDayPicker = ({ classNames }: { classNames?: ClassNames }) => {
  const { vendorSearch } = useSearchResultsPageContext();
  const { navigateToSrp } = useVendorSearchNavigation();
  const { availabilityDates } = vendorSearch;
  return (
    <div>
      <DayPicker
        mode="multiple"
        className="facet-button__calendar"
        classNames={classNames}
        fromMonth={today}
        toMonth={twoYearsOut}
        selected={availabilityDates?.map((date) => parseDate(date, 'YYYY-MM-DD')) || undefined}
        captionLayout="dropdown"
        onSelect={(selectedDates: Date[] | undefined) => {
          if (selectedDates) {
            navigateToSrp({
              availabilityDates: selectedDates.map((date) => formatDate(date, 'YYYY-MM-DD')),
            });
          }
        }}
      />
      <div>
        You have selected{' '}
        {pluralize('day', 'days', vendorSearch.availabilityDates?.length || 0, true)}
      </div>
    </div>
  );
};

export default AvailabilityFilterDayPicker;
